import { useState } from "react";
import { MultiChipSelectOption } from "../multiChipSelect/multiChipSelect";
import { ActiveFilter } from "src/app/crawler/crawler.interface";
import Button from "../../button/button";
import './pageTypeFilter.scss';
import CheckAllFilter from "../checkAll/checkAllFilter";

export interface PageTypeFilterProps {
    name: string;
    options: MultiChipSelectOption[];
    defaultSelectedPageTypeOptions?: MultiChipSelectOption[];
    defaultConfidenceLevel?: MultiChipSelectOption;
    handleSubmit: (filter: ActiveFilter) => void;
}

export interface PageTypeOption extends MultiChipSelectOption{
    isChecked: boolean;
}

function PageTypeFilter(
    {
        name,
        options,
        defaultSelectedPageTypeOptions,
        defaultConfidenceLevel,
        handleSubmit,
    }: PageTypeFilterProps) {

    const [selectedChip, setSelectedChip] = useState<MultiChipSelectOption>(() => checkDefaultConfidenceLevel());
    const [pageTypeOptions, setPageTypeOptions] = useState<PageTypeOption[]>(() => checkDefaultPageType());

    function checkDefaultPageType(): PageTypeOption[] {
        const allPageTypeOptions: PageTypeOption[] = [];
        options.map(opt => {
            let isCheckedIndex;
            if (defaultSelectedPageTypeOptions && defaultSelectedPageTypeOptions.length > 0) {
                isCheckedIndex = defaultSelectedPageTypeOptions?.findIndex((defaultOption: MultiChipSelectOption) => opt.value == defaultOption.value);
            } else {
                isCheckedIndex = -1;
            }
            allPageTypeOptions.push({
                ...opt,
                isChecked: isCheckedIndex > -1 ? true : false
            });
        });
        return allPageTypeOptions;
    }

    function checkDefaultConfidenceLevel() {
        return defaultConfidenceLevel ? defaultConfidenceLevel : { name: 'all', value: 'all', label: 'All' };
    }

    function handlePageTypeOptionChange(option: PageTypeOption) {
        const allOptions = [...pageTypeOptions];
        const index = allOptions.findIndex((opt: PageTypeOption) => opt.value == option.value);
        // Toggle isChecked
        allOptions[index].isChecked = !allOptions[index].isChecked;
        setPageTypeOptions([...allOptions]);
    }

    function submitPageTypeFilter() {
        const allPageTypeOptions = [...pageTypeOptions];
        const selectedFilterOptions: MultiChipSelectOption[] = [];
        allPageTypeOptions.map(opt => {
            if (opt.isChecked === true) {
                selectedFilterOptions.push({
                    name: opt.name,
                    value: opt.value,
                    label: opt.label
                });
            }
        });
        const filterVal = selectedFilterOptions.map((chip: MultiChipSelectOption) => chip.value).join('|');
        const filter: ActiveFilter = { name: name, value: filterVal, confidenceLevel: selectedChip.value };
        handleSubmit(filter);
    }

    const confidenceLevelSingleChipSelectors: MultiChipSelectOption[] = [
        { name: 'high', value: 'high', label: 'High' },
        { name: 'medium', value: 'medium', label: 'Medium' },
        { name: 'low', value: 'low', label: 'Low' },
        { name: 'all', value: 'all', label: 'All' },
    ];

    function toggleCheckAll(check: boolean) {
        const allPageTypeOptions = [...pageTypeOptions];
        const allCheckedPageTypeOptions = allPageTypeOptions.map(opt => { 
            return {...opt, isChecked: check};
        });
        setPageTypeOptions([...allCheckedPageTypeOptions]);
    }

    return (
        <div data-testid="page-type-filter-wrapper">
            <ul className="page-type--wrapper" data-testid="page-type-filter">
                <CheckAllFilter toggleCheckAll={toggleCheckAll} />
                { pageTypeOptions.length > 0 &&
                    pageTypeOptions.map((option: PageTypeOption) => (
                        <li key={option.value} className={"page-type--item"} data-testid="page-type--list-item">
                            <input className={"page-type--checkbox " + (option.isChecked ? "selected" : "")} 
                                type="checkbox" name={option.value} 
                                data-testid="page-type--checkbox"
                                value={option.value} 
                                checked={option.isChecked}
                                onChange={() => handlePageTypeOptionChange(option)} 
                                id={option.value}
                            />
                            <label htmlFor={option.value}>{option.label}</label>
                        </li>
                    ))
                }
            </ul>
            <span title="defaults to 'All'" className="title"><b>Confidence Level </b> &nbsp; <i className="optional"> (optional)</i></span>
            <div className="single-chip-wrapper" data-testid="confidence-filter">
                {confidenceLevelSingleChipSelectors.map((option: MultiChipSelectOption) => (
                    <div className={"chip-single " + (selectedChip?.value == option.value ? 'selected-single' : '')} key={option.value} onClick={() => setSelectedChip(option)}>
                        <span className={option.value}>{option.label}</span>
                    </div>
                ))}
            </div>
            <div className="center-button">
                <Button variant="button button--small" onClick={submitPageTypeFilter}>Submit</Button>
            </div>
        </div>
    );
}

export default PageTypeFilter;